/*
 * Gráfica de barras verticales del tablero, sobre el motor unificado de
 * gráficas (Echartxx de codekit, FASE 5): ticks en COP, tooltip y
 * animación nativos. Reemplaza la réplica artesanal de Chart.js en CSS.
 */
import { useMemo } from "react";

import { Echartxx } from "codekit";

import { fmtCOP, htmlTheme } from "./utils/carthelp";

/**
 * Renderiza una gráfica de barras verticales con ejes y gridlines
 * @param {Object} props Propiedades del componente
 * @param {Array} props.data Filas [{ label, value, color, raw }]
 * @param {Function} props.onItemClick Callback con la fila y su índice al hacer click
 * @param {number} props.height Alto total del área de la gráfica
 */
const Vertbars = ({ data = [], onItemClick, height = 260 }) => {
  const bClickable = typeof onItemClick === "function";

  const opcion = useMemo(
    () => ({
      tooltip: {
        trigger: "item",
        formatter: (params) => {
          const mItem = data[params.dataIndex] ?? {};
          return `<b>${mItem.raw || mItem.label}</b><br/>${fmtCOP(mItem.value)}`;
        },
      },
      grid: { left: 8, right: 12, top: 12, bottom: 4, containLabel: true },
      xAxis: {
        type: "category",
        data: data.map((mItem) => mItem.label),
        axisLabel: {
          interval: 0,
          fontSize: 11,
          color: htmlTheme.muted,
          overflow: "truncate",
          width: Math.max(60, Math.floor(900 / Math.max(1, data.length))),
        },
      },
      yAxis: {
        type: "value",
        axisLabel: { fontSize: 10, color: htmlTheme.muted, formatter: (nValor) => fmtCOP(nValor) },
      },
      series: [
        {
          type: "bar",
          cursor: bClickable ? "pointer" : "default",
          itemStyle: {
            borderRadius: [6, 6, 0, 0],
            color: (params) => data[params.dataIndex]?.color || htmlTheme.navy,
          },
          emphasis: { itemStyle: { opacity: 0.85 } },
          data: data.map((mItem) => Math.abs(mItem.value)),
        },
      ],
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data],
  );

  const eventos = useMemo(
    () => ({
      click: (params) => {
        const mItem = data[params.dataIndex];
        if (bClickable && mItem !== undefined) {
          onItemClick(mItem, params.dataIndex);
        }
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, onItemClick],
  );

  return <Echartxx option={opcion} onEvents={eventos} height={height} />;
};

export default Vertbars;
